import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { TextFormat, Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { APP_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './deal.reducer';

export const DealDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const dealEntity = useAppSelector(state => state.deal.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="dealDetailsHeading">
          <Translate contentKey="tycheApp.deal.detail.title">Deal</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tycheApp.deal.id">Id</Translate>
            </span>
          </dt>
          <dd>{dealEntity.id}</dd>
          <dt>
            <span id="name">
              <Translate contentKey="tycheApp.deal.name">Name</Translate>
            </span>
          </dt>
          <dd>{dealEntity.name}</dd>
          <dt>
            <span id="cashBackCurr">
              <Translate contentKey="tycheApp.deal.cashBackCurr">Cash Back Curr</Translate>
            </span>
          </dt>
          <dd>{dealEntity.cashBackCurr}</dd>
          <dt>
            <span id="cashBackAmt">
              <Translate contentKey="tycheApp.deal.cashBackAmt">Cash Back Amt</Translate>
            </span>
          </dt>
          <dd>{dealEntity.cashBackAmt}</dd>
          <dt>
            <span id="buzzCommission">
              <Translate contentKey="tycheApp.deal.buzzCommission">Buzz Commission</Translate>
            </span>
          </dt>
          <dd>{dealEntity.buzzCommission}</dd>
          <dt>
            <span id="publisherCommission">
              <Translate contentKey="tycheApp.deal.publisherCommission">Publisher Commission</Translate>
            </span>
          </dt>
          <dd>{dealEntity.publisherCommission}</dd>
          <dt>
            <span id="redeemPoint">
              <Translate contentKey="tycheApp.deal.redeemPoint">Redeem Point</Translate>
            </span>
          </dt>
          <dd>{dealEntity.redeemPoint}</dd>
          <dt>
            <span id="imagePath">
              <Translate contentKey="tycheApp.deal.imagePath">Image Path</Translate>
            </span>
          </dt>
          <dd>{dealEntity.imagePath}</dd>
          <dt>
            <span id="validityFrom">
              <Translate contentKey="tycheApp.deal.validityFrom">Validity From</Translate>
            </span>
          </dt>
          <dd>{dealEntity.validityFrom ? <TextFormat value={dealEntity.validityFrom} type="date" format={APP_DATE_FORMAT} /> : null}</dd>
          <dt>
            <span id="validityTo">
              <Translate contentKey="tycheApp.deal.validityTo">Validity To</Translate>
            </span>
          </dt>
          <dd>{dealEntity.validityTo ? <TextFormat value={dealEntity.validityTo} type="date" format={APP_DATE_FORMAT} /> : null}</dd>
          <dt>
            <span id="type">
              <Translate contentKey="tycheApp.deal.type">Type</Translate>
            </span>
          </dt>
          <dd>{dealEntity.type}</dd>
          <dt>
            <span id="category">
              <Translate contentKey="tycheApp.deal.category">Category</Translate>
            </span>
          </dt>
          <dd>{dealEntity.category}</dd>
          <dt>
            <span id="instruction">
              <Translate contentKey="tycheApp.deal.instruction">Instruction</Translate>
            </span>
          </dt>
          <dd>{dealEntity.instruction}</dd>
          <dt>
            <span id="termsAndConditions">
              <Translate contentKey="tycheApp.deal.termsAndConditions">Terms And Conditions</Translate>
            </span>
          </dt>
          <dd>{dealEntity.termsAndConditions}</dd>
          <dt>
            <span id="inventoryTracking">
              <Translate contentKey="tycheApp.deal.inventoryTracking">Inventory Tracking</Translate>
            </span>
          </dt>
          <dd>{dealEntity.inventoryTracking ? 'true' : 'false'}</dd>
          <dt>
            <span id="stockLevel">
              <Translate contentKey="tycheApp.deal.stockLevel">Stock Level</Translate>
            </span>
          </dt>
          <dd>{dealEntity.stockLevel}</dd>
          <dt>
            <span id="createdAt">
              <Translate contentKey="tycheApp.deal.createdAt">Created At</Translate>
            </span>
          </dt>
          <dd>{dealEntity.createdAt ? <TextFormat value={dealEntity.createdAt} type="date" format={APP_DATE_FORMAT} /> : null}</dd>
          <dt>
            <span id="createdBy">
              <Translate contentKey="tycheApp.deal.createdBy">Created By</Translate>
            </span>
          </dt>
          <dd>{dealEntity.createdBy}</dd>
          <dt>
            <span id="updatedAt">
              <Translate contentKey="tycheApp.deal.updatedAt">Updated At</Translate>
            </span>
          </dt>
          <dd>{dealEntity.updatedAt ? <TextFormat value={dealEntity.updatedAt} type="date" format={APP_DATE_FORMAT} /> : null}</dd>
          <dt>
            <span id="updatedBy">
              <Translate contentKey="tycheApp.deal.updatedBy">Updated By</Translate>
            </span>
          </dt>
          <dd>{dealEntity.updatedBy}</dd>
          <dt>
            <Translate contentKey="tycheApp.deal.merchant">Merchant</Translate>
          </dt>
          <dd>{dealEntity.merchant ? dealEntity.merchant.id : ''}</dd>
          <dt>
            <Translate contentKey="tycheApp.deal.publisher">Publisher</Translate>
          </dt>
          <dd>{dealEntity.publisher ? dealEntity.publisher.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/deal" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/deal/${dealEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default DealDetail;
